import PictureViewer from "@/components/core/PictureViewer";
import { myIcons } from "@/utils/icons"
import "./style.css";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import statics from "@/utils/statics.json";
const { iconBaseUrl } = statics;

export const Experiences = () => {
    const { t } = useTranslation();
    const experienceIcons: Record<string, string> = {
        euas: myIcons.experiences.euas,
        coruh: myIcons.experiences.coruh,
    };

    const experiences = t("experiences", {
        returnObjects: true,
    }) as ExperienceI[];

    return (
        <div style={{ color: "var(--color-text)" }}>
            <p style={{ fontSize: "25px", marginBottom: "20px" }}>
                {t("experiences-title")}
            </p>

            {experiences.map(exp => (
                <ExperiencesItem
                    key={exp.id}
                    icon={`${iconBaseUrl}${exp.id}.svg`}
                    {...exp}
                />
            ))}
        </div>
    );
};

interface DepartmentI {
    subTitle: string;
    time: string;
    description: string;
    images?: string[];
}


interface ExperienceI {
    id: string;
    title: string;
    workplace: string;
    time: string;
    departments: DepartmentI[];
}


interface DepartmentsItemPropsI {
    subTitle: string;
    time: string;
    description: string;
    images?: string[];
}

const DepartmentsItem = ({ subTitle, time, description, images }: DepartmentsItemPropsI) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
        >
            <div style={{ display: 'flex', flexDirection: 'row', marginTop: '20px' }} >
                <div
                    style={{
                        width: '10px',
                        height: '10px',
                        backgroundColor: '#3f51b5',
                        borderRadius: '100px',
                        flexShrink: 0,
                        marginRight: '20px',
                    }}
                ></div>
                <div style={{ maxWidth: '600px', transform: 'translateY(-5px)', }} >
                    <div style={{ display: 'flex', marginBottom: '5px', gap: '10px' }}>
                        <p style={{ fontWeight: 'bold' }} >{subTitle}</p>
                        <p style={{ color: 'grey' }} >{time}</p>
                    </div>
                    <p>{description}</p>
                    {images?.length ? (
                        <div style={{ marginTop: "15px" }}>
                            <PictureViewer images={images} />
                        </div>
                    ) : null}

                </div>
            </div>
        </motion.div >);
}

interface ExperiencesItemPropsI {
    icon: string;
    title: string;
    workplace: string;
    time: string;
    departments: DepartmentsItemPropsI[]
}

const ExperiencesItem = ({ icon, title, workplace, time, departments }: ExperiencesItemPropsI) => {
    const isEuas: boolean = icon === myIcons.experiences.euas;
    return (
        <div
            className="experiences-item"
            style={{
                display: 'flex',
                gap: '30px',
                marginBottom: '50px',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    backgroundColor: '#dcdcdcff',
                    alignItems: 'center',
                    width: '50px',
                    height: '50px',
                    padding: '5px',
                    borderRadius: '10px',
                    boxShadow: '0 2px 8px rgba(33, 33, 33, 0.5)',
                }}
            >
                <div
                    style={{
                        borderRadius: '5px',
                        overflow: 'hidden',
                        display: 'inline-block',
                    }}
                >
                    <img
                        style={{
                            width: '100%',
                            height: 'auto',
                            objectFit: 'contain',
                            display: 'block',
                        }}
                        src={icon}
                        alt=""
                    />
                </div>

            </div>

            <div>
                <h4>{title}</h4>
                <p>{workplace}</p>
                <p
                    style={{ color: '#9e9e9e', marginBottom: '20px' }}
                >{time}</p>
                <div
                    style={{ display: 'flex', flexDirection: 'row' }}
                >
                    <div style={{
                        width: '10px',
                        backgroundColor: '#dcdcdcff',
                        borderRadius: '100px',
                        flexShrink: 0
                    }} ></div>
                    <div style={{
                        display: 'flex', flexDirection: 'column', gap: '30px', transform: 'translateX(-10px)'
                    }}>

                        {departments.map((dep, index) => (
                            <DepartmentsItem key={index} {...dep} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}